class ReviewCarousel extends window.BAO.Carousel.Element {
  initialiseCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.1,
          spacing: 20,
        },
        breakpoints: {
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.xs}px)`]: {
            slides: {
              perView: 1.7,
              spacing: 20,
            },
          },
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.sm}px)`]: {
            slides: {
              perView: 2.1,
              spacing: 20,
            },
          },
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.md +
            1}px)`]: {
            slides: {
              perView: 3.2,
              spacing: 30,
            },
          },
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.lg +
            1}px)`]: {
            slides: {
              perView: 2.1,
              spacing: 40,
            },
          },

          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.xlg +
            1}px)`]: {
            slides: {
              perView: 2.2,
              spacing: 40,
            },
          },
        },
      },
      [
        window.BAO.Carousel.useInitialised(),
        window.BAO.Carousel.useDots(this.els.dot.elements),
        window.BAO.Carousel.useArrows({
          next: this.els.next.element,
          previous: this.els.previous.element,
        }),
      ],
    )
  }
}

if (!customElements.get('review-carousel')) {
  customElements.define('review-carousel', ReviewCarousel)
}
